import type {
  CurrencyEntity,
} from '@dinosave/scraping/types';
import CurrencyList from '@/components/CurrencyList';
import {
  Modal,
} from '@/components/Modals';
import type {
  ModalProps,
} from '@/components/Modals';

import styles from './SelectCurrencyModal.module.css';

type SelectCurrencyModalProps = ModalProps & {
  onChange?: (currency: CurrencyEntity) => void;
};

const SelectCurrencyModal = (props: SelectCurrencyModalProps) => {
  // ##########################################################################
  // PROPS
  // ##########################################################################

  const {
    onChange,
    ...rest
  } = props;

  // ##########################################################################
  // RENDER
  // ##########################################################################

  return (
    <Modal
      {...rest}
      className={styles.selectCurrencyModal}
      contentClassName={styles.content}
    >
      <div className={styles.currencyList}>
        <CurrencyList onChange={onChange} />
      </div>
    </Modal>
  );
};

export default SelectCurrencyModal;
